import { FormSection } from '@features/components/CaseFormBlocks/components';
import { MatchIdRow } from './MatchIdRow';

/** nop-connect only; OPO puts Match ID inside each organ section. */
export const CaseMatchSection = () => (
  <FormSection title="Case Match">
    <MatchIdRow />
  </FormSection>
);
